import src from "IMAGE";
export default { src, width: 133, height: 44, blurWidth: 0, blurHeight: 0};
